/* ============================================================================
   haiku-nav-paint — the label inks in from wherever the pointer touched it

   No underline. Hovering floods the word with ink, and the flood starts at the
   exact point of contact and spreads out, so entering from the left fills
   left-to-right and entering from the right fills the other way.

   HOW: two stacked copies of the same drawing. The lower one is the resting,
   lighter state; the upper is full ink, revealed through
   `clip-path: circle(R at X Y)`. X/Y come from the pointer, R animates 0 -> past
   the far corner. Clip-path is compositor-friendly, so this is a cheap paint.

   ⚠️ The header is mix-blend-mode: difference. Inside it, WHITE renders as
   near-black against the light ground and dark renders as nothing. So "more
   ink" here means MORE WHITE, not darker. Setting these to #141414 — the
   correct-looking value — is what made them grey.

   Fail-safe: if this never runs, the words sit at their resting weight and the
   link still works. Nothing here is required for navigation.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.haikuNavPaintConfig || {};
  if (cfg.enabled === false) return;

  var GROW = typeof cfg.grow === 'number' ? cfg.grow : 520;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function wire(link) {
    if (link.__hnPaint) return;
    var word = link.querySelector('.hn-word');
    if (!word) return;
    var svg = word.querySelector('.hn-word__svg');
    if (!svg) return;

    // The ink copy is a clone, so the two can never drift apart.
    var ink = svg.cloneNode(true);
    ink.setAttribute('class', 'hn-word__svg hn-word__ink');
    word.appendChild(ink);
    link.__hnPaint = true;

    var set = function (e, r) {
      var b = word.getBoundingClientRect();
      if (!b.width) return;
      // Contact point in the word's own coordinates, as a percentage so the
      // clip stays correct if the word is resized.
      var x = ((e.clientX - b.left) / b.width) * 100;
      var y = ((e.clientY - b.top) / b.height) * 100;
      ink.style.setProperty('--hx', x.toFixed(1) + '%');
      ink.style.setProperty('--hy', y.toFixed(1) + '%');
      ink.style.setProperty('--hr', r);
    };

    link.addEventListener('pointerenter', function (e) {
      if (reduced()) { ink.style.setProperty('--hr', '150%'); return; }
      // Seed the origin with the radius still closed, force it to commit, then
      // grow — otherwise the browser coalesces both writes and the circle
      // expands from wherever it was last time.
      set(e, '0%');
      void ink.getBoundingClientRect();
      ink.style.setProperty('--hr', '150%');
    });

    link.addEventListener('pointerleave', function (e) {
      if (reduced()) { ink.style.setProperty('--hr', '0%'); return; }
      // Drain back toward the exit point, so leaving reads as the reverse of
      // arriving rather than a fade.
      set(e, '0%');
    });
  }

  function boot() {
    var links = document.querySelectorAll('.hn-link');
    for (var i = 0; i < links.length; i++) wire(links[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // haiku-nav.js clones these links into the header after boot, so re-wire once
  // the clones have landed.
  window.setTimeout(boot, 400);
  window.setTimeout(boot, 1400);
})();
